module.exports = __webpack_public_path__ + "img/Frame 1049three.2b69992f.png";